import React from 'react';
import cn from 'classnames';
import { Typography, Divider, Tooltip, TooltipPlacement } from '@ezetech/swag-space-x';
import { variables } from 'swag-client-common/styles/variables-js';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { Price } from 'swag-common/utils/price';
import css from './you-will-make.scss';
export const YouWillMakeComponent = ({
  className,
  isResellerAdminMode,
  resellersCommission,
  productsCommission,
  isPromocodeDiscountPresent
}) => {
  const tooltipPlacement = isMobile() ? TooltipPlacement.bottom : TooltipPlacement.left;
  if (isResellerAdminMode) {
    return /*#__PURE__*/React.createElement("section", {
      className: cn(css.wrapper, className)
    }, /*#__PURE__*/React.createElement(Typography, {
      lineHeight: "141.667%",
      fontType: "bodyLgBold",
      color: variables.colorPrimaryText
    }, "You will make ", Price.formatPrice(resellersCommission)), /*#__PURE__*/React.createElement(Divider, {
      color: variables.colorPrimaryText,
      className: css.divider
    }), /*#__PURE__*/React.createElement(Typography, {
      lineHeight: "162.5%",
      fontType: "bodyMd",
      color: variables.colorPrimaryText
    }, "This is based on your commission structure and the", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      placement: tooltipPlacement,
      withArrow: true,
      disabled: !productsCommission.length,
      triggerClassName: css.products,
      bodyClassName: css.bodyClassName,
      trigger: /*#__PURE__*/React.createElement(Typography, {
        lineHeight: "162.5%",
        fontType: "bodyMd",
        color: variables.colorResellerPink,
        className: css.products
      }, "products")
    }, /*#__PURE__*/React.createElement("div", {
      className: css.productList
    }, productsCommission.map(({
      name,
      commission,
      itemId
    }, index) => /*#__PURE__*/React.createElement(Typography, {
      key: `${name}-${index}`,
      lineHeight: "142.857%",
      fontType: "bodySm",
      color: variables.colorPrimaryText,
      className: css.productItem,
      "data-item-id": itemId
    }, name, " - ", commission.toFixed(), "%")))), ' ', "that you\u2019ve selected.", isPromocodeDiscountPresent && /*#__PURE__*/React.createElement("span", null, ' ', "Note that the promo code value will be deducted from your commission.")));
  }
  return null;
};